const $document = $(document);

const handleOptions = () => {
  $document.on('change', '.js-pdp-option', function() {
    const $this = $(this);
    const $parent = $this.closest('form');
    const $masterSelect = $parent.find('.js-product-main-select');
    let targetVariant = '';

    if ($this.prop('checked') === false && $this.hasClass('js-pdp-option-color')) {
      return;
    }

    // radio/checkbox option
    $parent.find('.js-pdp-option-color:checked').each(function() {
      const $this = $(this);
      const $productBarColorContainer = $('.js-main-pdp-color-name');

      if ($productBarColorContainer.length > 0) {
        $productBarColorContainer.text($this.data('color-name'));
      }

      targetVariant += `[data-option-${$this.data('option-position')}="${$this.val()}"]`;
    });

    // select option
    $parent.find('.js-pdp-option').not('.js-pdp-option-color').each(function() {
      const $this = $(this);

      targetVariant += `[data-option-${$this.data('option-position')}="${$this.val()}"]`;
    });

    $masterSelect
      .find(targetVariant)
      .prop('selected', true)
      .trigger('change');
  });
}

handleOptions();
